import { useState, useEffect } from 'react';
import fleetApi from '../../services/api.service';

export default function useGetReserveDetailsV2(reserve_id) {
  const [reserve, setReserve] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (reserve_id) {
      getReserveDetails();
    }
  }, [reserve_id]);

  const getReserveDetails = async () => {
    try {
      setIsLoading(true);

      const url = `/reserves/${reserve_id}`;
      const response = await fleetApi.get(url);

      if (response.status === 200) {
        setReserve(response.data?.reserve || null);
      } else {
        throw new Error('Failed to fetch tour details');
      }
    } catch (error) {
      setError(error?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return {
    reserve,
    error,
    isLoading,
    refetch: getReserveDetails,
  };
}
